/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Button, Card, CardBody, Heading, Flex } from "@chakra-ui/react";
import Loader from "../../components/PageLoader";
import BreadCrumb from "../../components/breadCrumb";
import { Paths } from "../../routes/paths";
import { useAddStock } from "../../services/stock";
import {
  useLookupCustomers,
  useLookupMachineMakers,
  useLookupCashCenters,
  useLookupCurrencyMultiples,
} from "../../services/lookups-mutations";
import { useLookupCurrency } from "../../services/lookups-queries";
import ReactHookFormDropdown from "../../components/forms/react-hook-dropdown";
import FormInput from "../../components/forms/form-Input";
import NumericInput from "../../components/forms/react-hook-numeric-input";
import { CASSETTES_TYPES, DEFAULT_STOCK } from "./constants";

export default function AddStock() {
  const navigate = useNavigate();
  const {
    mutate: getCustomers,
    data: customerListRes,
    isPending: gettingCustomerList,
    // error: customerListError,
  } = useLookupCustomers();

  const {
    mutate: getMakersList,
    data: makersListRes,
    isPending: gettingMakersList,
    // error: makersListError,
  } = useLookupMachineMakers();
  const {
    mutate: getCashCenter,
    data: cashCenterList,
    isPending: gettingCashCenterList,
    // error: cashCenterListError,
  } = useLookupCashCenters();
  const {
    data: currencyListRes,
    isPending: gettingCurrencyList,
    // error: currencyError,
  } = useLookupCurrency();
  const {
    mutate: getMultiples,
    data: multipleList,
    // isPending: gettingMultiples,
    // error: multipleError,
    reset: multipleReset,
  } = useLookupCurrencyMultiples();
  const {
    mutate: createRequest,
    data: createRequestResponse,
    isPending: creatingRequest,
  } = useAddStock();
  useEffect(() => {
    getCustomers();
    getCashCenter();
    getMakersList();
  }, []);
  useEffect(() => {
    if (createRequestResponse) {
      navigate(Paths.stock);
    }
  }, [createRequestResponse]);
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: { ...DEFAULT_STOCK },
  });
  const formValidationRules = {
    cashCenterId: { required: "Please select cash center" },
    customerId: { required: "Please select customer" },
    description: { required: "Please add description" },
    currency: { required: "Please select currency" },
    multiple: { required: "Please select multiple" },
    cassetteType: { required: "Please select cassette type" },
    maker: { required: "Please select maker" },
    topSerialNo: { required: "Please add top serial no" },
  };
  const generalFieldProps = { errors, control };
  const onCurrencyChange = (_value) => {
    multipleReset();
    if (_value !== "0") {
      getMultiples(_value);
    }
  };
  const onSubmit = (data) => {
    const _payload = {
      cashCenterId: data.cashCenterId || "",
      customerId: data.customerId || "",
      description: data.description,
      denomination:
        data.currency && data.multiple
          ? `${data.currency} ${data.multiple}`
          : "",
      cassetteType: data.cassetteType || "",
      maker: data.maker,
      limit: !data.limit || data.limit === "0" ? 0 : data.limit,
      topSerialNo: data.topSerialNo,
      bottomSerialNo: data.bottomSerialNo,
    };
    // console.log(_payload);
    createRequest(_payload);
  };
  return (
    <>
      {gettingCurrencyList ||
      gettingCashCenterList ||
      gettingCustomerList ||
      creatingRequest ||
      gettingMakersList ? (
        <Loader />
      ) : (
        <></>
      )}

      <div className="form-container">
        <BreadCrumb
          links={[
            { text: "Stocks", link: Paths.stock },
            { text: "Add Stock", isCurrentPage: true },
          ]}
        />
        <Flex w="100%">
          <Card flexDirection="column" w="100%">
            <CardBody>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "16px",
                }}
              >
                <Heading>Add Stock</Heading>
                <Button as={Link} to={Paths.addStockBulk}>
                  Add Bulk
                </Button>
              </div>

              <form
                onSubmit={handleSubmit(onSubmit)}
                className="add-location-form"
              >
                <ReactHookFormDropdown
                  {...generalFieldProps}
                  isRequired
                  label="Cash Center"
                  name="cashCenterId"
                  data={cashCenterList?.data.map(item => ({ value: item.cashCenterId, label: item.name })) || []}
                  placeholder="Select Cash Center"
                  rules={formValidationRules.cashCenterId}
                />
                <ReactHookFormDropdown
                  {...generalFieldProps}
                  isRequired
                  label="Customer"
                  name="customerId"
                  data={customerListRes?.data.map(item => ({ value: item.customerId, label: item.name })) || []}
                  placeholder="Select Customer"
                  rules={formValidationRules.customerId}
                />
                <FormInput
                  {...generalFieldProps}
                  isRequired
                  label="Description"
                  name="description"
                  rules={formValidationRules.description}
                />
                <ReactHookFormDropdown
                  {...generalFieldProps}
                  isRequired
                  label="Currency"
                  name="currency"
                  data={currencyListRes?.data.map(item => ({ value: item.shortName, label: item.name })) || []}
                  placeholder="Select Currency"
                  rules={formValidationRules.currency}
                  onChange={onCurrencyChange}
                  dropdownProps={{ filterable: true }}
                />
                <ReactHookFormDropdown
                  {...generalFieldProps}
                  isRequired
                  label="Multiple"
                  name="multiple"
                  data={
                    multipleList?.data.map((elm) => ({
                      value: elm.multiple.toString(),
                      label: elm.multiple.toString(),
                    })) || []
                  }
                  placeholder="Select Multiple"
                  rules={formValidationRules.multiple}
                  dropdownProps={{ filterable: true }}
                />
                <ReactHookFormDropdown
                  {...generalFieldProps}
                  isRequired
                  label="Cassette Type"
                  name="cassetteType"
                  data={CASSETTES_TYPES}
                  placeholder="Select Cassette Type"
                  rules={formValidationRules.cassetteType}
                />
                <ReactHookFormDropdown
                  {...generalFieldProps}
                  isRequired
                  label="Maker"
                  name="maker"
                  rules={formValidationRules.maker}
                  data={makersListRes?.data.map(item => ({ value: item.name, label: item.name })) || []}
                  placeholder="Select Maker"
                />
                <NumericInput
                  {...generalFieldProps}
                  label="Limit"
                  name="limit"
                />
                <FormInput
                  {...generalFieldProps}
                  isRequired
                  label="Top Serial No"
                  name="topSerialNo"
                  rules={formValidationRules.topSerialNo}
                />
                <FormInput
                  {...generalFieldProps}
                  label="Bottom Serial No"
                  name="bottomSerialNo"
                />
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "16px",
                  }}
                >
                  <Button type="submit">Add Stock</Button>
                </div>
              </form>
            </CardBody>
          </Card>
        </Flex>
      </div>
    </>
  );
}
